import React from "react";
import BasePricesDashboardActions from "./actions/BasePricesDashboardActions";
import DateHelper from "../DateHelper/DateHelper";
import DashboardDatePicker from '../DashboardDatePicker/DashboardDatePicker';
import { addDays, isSameDay } from 'date-fns'

class BasePricesDashboardHeader extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeDate = this.onChangeDate.bind(this);
        this.onToday = this.onToday.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
    }

    render() {
        return (
            <div className="row dashboard-buttons">
                <div className="col-sm-12">
                    <div className="text-center">
                        <button type="button" className="prev-button btn btn-secondary" onClick={this.onPrev}><span className="icon ss-left"></span></button>
                        {
                        isSameDay(new Date(this.props.currentDate), new Date())
                        ? 
                        <DashboardDatePicker
                          classNames={'current-date'}
                          selectedDate={this.props.currentDate}
                          dateFormat={this.props.dateFormat}
                          onChange={this.onChangeDate}
                        />
                        : 
                        <DashboardDatePicker
                          selectedDate={this.props.currentDate}
                          dateFormat={this.props.dateFormat}
                          onChange={this.onChangeDate}
                        />
                        }
                        <button type="button" className="next-button btn btn-dark" onClick={this.onNext}><span className="icon ss-right"></span></button>
                    </div>
                </div>
            </div>
        );
    };

    onChangeDate(date) {
      BasePricesDashboardActions.gotoDate(date);
    };

    onToday() {
      BasePricesDashboardActions.gotoDate(new Date());
    };

    onPrev() {
        var prevDate = new Date(this.props.currentDate);
        prevDate.setDate(prevDate.getDate() - 1);
        BasePricesDashboardActions.gotoDate(prevDate);
    };

    onNext() {
        var nextDate = new Date(this.props.currentDate);
        nextDate.setDate(nextDate.getDate() + 1);
        BasePricesDashboardActions.gotoDate(nextDate);
    };

};

export default BasePricesDashboardHeader